module.exports = new __parcel__URL__("favicon-temp-jpd.d360a2a3.png").toString();